import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import content from './content';
import runBehaviors from './behaviors';
import { attachDeferredMedia } from './deferred-media';
import { createSectionLifecycle } from './lifecycle';
import { attachHeroCounters, attachHeroNavigation } from './hero-interactions';
import './sections.css';
import './integration.css';
import './hero.css';

export default function HomepageSections() {
  const container = useRef<HTMLElement>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const root = container.current;
    if (!root) return undefined;
    const lifecycle = createSectionLifecycle(root);
    runBehaviors(lifecycle.environment);
    const detachMedia = attachDeferredMedia(root);
    const detachHeroNavigation = attachHeroNavigation(root, hash => navigate(hash, { preventScrollReset: true }));
    const detachHeroCounters = attachHeroCounters(root);
    root.dataset.interactions = 'ready';
    const onLink = (event: MouseEvent) => {
      if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const anchor = (event.target as Element).closest<HTMLAnchorElement>('a[href]');
      if (!anchor || anchor.target === '_blank' || anchor.hasAttribute('download')) return;
      const url = new URL(anchor.href, location.href);
      if (url.origin !== location.origin || !anchor.getAttribute('href')?.startsWith('/')) return;
      if (url.pathname === location.pathname && url.hash) return;
      event.preventDefault();
      navigate(`${url.pathname}${url.search}${url.hash}`);
    };
    root.addEventListener('click', onLink);
    return () => { root.removeEventListener('click', onLink); detachHeroNavigation(); detachHeroCounters(); detachMedia(); lifecycle.dispose(); };
  }, [navigate]);

  return <main ref={container} id="homepage-sections" className="homepage-sections mr-home-page" dangerouslySetInnerHTML={{ __html: content }} />;
}
